import React from "react";
import { Box, Typography, Backdrop, Fade, Modal as MuiModal } from "@mui/material";
import MDButton from "mdComponents/MDButton";

interface ClearLocationModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  clearing?: boolean;
}

const ClearLocationModal: React.FC<ClearLocationModalProps> = ({
  open,
  onConfirm,
  onCancel,
  clearing = false,
}) => {
  return (
    <MuiModal
      open={open}
      onClose={onCancel}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            alignItems: "stretch",
          }}
        >
          <Typography variant="h6" align="center">
            Clear Location Restroom?
          </Typography>
          <Typography variant="body2" align="center">
            This feature is used to clear error or long-running user sessions.
            <br />⚠️ Do this only if you are sure the restroom is clear of users.
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            <MDButton
              variant="outlined"
              color="secondary"
              onClick={onCancel}
              fullWidth
              sx={{ mr: 1 }}
            >
              No, Restroom is in Use
            </MDButton>
            <MDButton
              color="error"
              onClick={onConfirm}
              disabled={clearing}
              fullWidth
              sx={{ ml: 1 }}
            >
              {clearing ? "Clearing..." : "Yes, Clear the Restroom"}
            </MDButton>
          </Box>
        </Box>
      </Fade>
    </MuiModal>
  );
};

export default ClearLocationModal;
